import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-direct-authorization-setting-asd',
  templateUrl: './direct-authorization-setting-asd.component.html',
  styleUrls: ['./direct-authorization-setting-asd.component.scss']
})
export class DirectAuthorizationSettingAsdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
